import React from 'react';

const Section = () => {
  return (
    <div className="w-full xl:px-[10%] lg:px-[8%] xs:px-[5%] md:px-[6%] sm:px-[5%]   flex justify-center">
      <div className="flex xs:max-w-full  xs:py-4 py-20 items-center flex-col">
        <div>
          <h1 className="text-[55px] xs:text-[25px] sm:text-[32px] font-inter font-bold text-center xs:pb-6">
          DrunkMates:{' '}
            <span className="bg-gradient-to-r pl-4 from-[#250b16] to-[#870022] bg-clip-text text-transparent">
             Party Smart, Regret Less!
            </span>
          </h1>
        </div>
        <div className="flex items-center text-center">
          <p className="text-[23px] xs:text-[16px] px-14 lg:px-[5%]  xs:px-4 font-semibold font-inter text-[#777]">
          DrunkMates is your trusted partner for nights out, ensuring you can enjoy the party without the next-day regrets.          </p>
        </div>
        <div className="w-full flex flex-wrap justify-between pt-16 gap-6">
          <div className="flex flex-col xs:w-[45%] sm:w-[48%] lg:w-[23%] items-center gap-4">
            <img
              src="https://appblock.app/wp-content/uploads/2024/04/Better-focus.svg"
              alt="Better focus"
              className="xs:w-16 sm:w-20 w-26"
            />
            <h2 className="text-[#777] xs:text-[15px] sm:text-[18px] text-[22px] font-bold font-inter text-center">
            Block Calls & Texts
            </h2>
          </div>
          <div className="flex flex-col xs:w-[45%] sm:w-[48%] lg:w-[23%] items-center gap-4">
            <img
              src="https://appblock.app/wp-content/uploads/2024/04/Improved-sleep.svg"
              alt="Improved sleep"
              className="xs:w-16 sm:w-20 w-26"
            />
            <h2 className="text-[#777] xs:text-[15px] sm:text-[18px] text-[22px] font-bold font-inter text-center">
            Limit App Usage
            </h2>
          </div>
          <div className="flex flex-col xs:w-[45%] sm:w-[48%] lg:w-[23%] items-center gap-4">
            <img
              src="https://appblock.app/wp-content/uploads/2024/04/Meaningful-relationships.svg"
              alt="Meaningful relationships"
              className="xs:w-16 sm:w-20 w-26"
            />
            <h2 className="text-[#777] xs:text-[15px] sm:text-[18px] text-[22px] font-bold font-inter text-center">
            Customizable Control
            </h2>
          </div>
          <div className="flex flex-col xs:w-[45%] sm:w-[48%] lg:w-[23%] items-center gap-4">
            <img
              src="https://appblock.app/wp-content/uploads/2024/04/Mental-strenght.svg"
              alt="Mental strength"
              className="xs:w-16 sm:w-20 w-26"
            />
            <h2 className="text-[#777] xs:text-[15px] sm:text-[18px] text-[22px] font-bold font-inter text-center">
            Easy Activation
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section;


// import React from 'react'

// const Section = () => {
//   return (
//     <div className='w-full  px-[5%]  xs:px-[2%] mx-auto flex justify-center'>

//        <div className='flex  xs:max-w-full max-w-[1080px] xs:py-4  py-20 items-center flex-col'>
//         <div>
//         <h1 className="text-[72px] xs:text-[25px] xs:pb-6 sm:text-[32px]  font-inter font-bold" >
//   Save up to   
//   <span className="bg-gradient-to-r pl-4 from-[#2f97ff] to-[#3051ff] bg-clip-text text-transparent">
//     3 hours a day.
//   </span>
// </h1>
//         </div>
//         <div className='flex  items-center text-center '>
//         <p className='text-[23px] xs:text-center px-14 xs:px-0 font-semibold font-inter'> <span className='text-[#777]'>Do you often find yourself with your head down</span>, lost in mindless scrolling?  <span className='text-[#777] '>Managing screen time with AppBlock enhances focus and boosts productivity, yielding</span>  significant benefits.</p>
//         </div>
//         <div className='w-full xs:flex-wrap  xs:pt-16 flex justify-between pt-16'> 
// <div className='flex flex-col xs:w-[50%] gap-6 xs:gap-2 xs:pb-12'>
//     <p className='flex justify-center'> <img src="https://appblock.app/wp-content/uploads/2024/04/Better-focus.svg" alt="" className='xs:w-16  w-26'/></p>
   
//     <h2 className='text-[#777] xs:text-[15px] xs:text-center font-bold text-[22px] font-inter'>Better focus </h2>
// </div>
// <div className='flex flex-col xs:w-[50%] gap-6 xs:gap-2 xs:pb-12'>
// <p className='flex justify-center'> <img src="https://appblock.app/wp-content/uploads/2024/04/Improved-sleep.svg" alt="" className='xs:w-16  w-26'/></p>
   
//    <h2 className='text-[#777] xs:text-[15px] xs:text-center font-bold text-[22px] font-inter'>Improved sleep </h2>
// </div>
// <div className='flex flex-col xs:w-[50%] gap-6 xs:gap-2 xs:pb-12'>
// <p className='flex justify-center'> <img src="https://appblock.app/wp-content/uploads/2024/04/Meaningful-relationships.svg" alt="" className='xs:w-16  w-26'/></p>
   
//    <h2 className='text-[#777] xs:text-center font-bold xs:text-[15px] text-[22px] font-inter'>Meaningful relationships  </h2>
// </div>
// <div className='flex flex-col xs:w-[50%] gap-6 xs:gap-2 xs:pb-12'>
// <p className='flex justify-center'> <img src="https://appblock.app/wp-content/uploads/2024/04/Mental-strenght.svg" alt="" className='xs:w-16  w-26' /></p>
   
//    <h2 className='text-[#777] xs:text-[15px] xs:text-center font-bold text-[22px] font-inter'>Mental strength </h2>
// </div>

//         </div>

      

//        </div>

//     </div>
//   )
// }

// export default Section